// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__22hjh","footer":"Form_footer__24ia_"};